import {
  IconActiveNow,
  IconBlocked,
  IconCompleted,
  IconCompletedWithDelay,
  IconFilled,
  IconInactive,
  IconIncomplete,
  IconLate,
  IconOverdue,
  IconPending,
  IconUpcomming,
  TTIconActiveNow,
  TTIconCompleted,
  TTIconCompletedWithDelay,
  TTIconFilled,
  TTIconInactive,
  TTIconIncomplete,
  TTIconLate,
  TTIconOverdue,
  TTIconPending,
  TTIconUpcomming,
} from '../icons';
import colors from '../styles/colors.scss';
import i18n from './i18n';

const { t } = i18n.i18n;

export const VALIDATION_ERROR_CODES = {
  DUPLICATE: 'Phone number already exists',
  INVALID_COUNTRY_CODE: 'Phone number has invalid country code',
  INVALID_LENGTH: 'Phone number should be between 8-14 characters',
  INVALID_PHONE_NUMBER: 'Phone number is not valid',
  STARTING_DIGIT_ERROR: 'Phone number should start with a digit 8"',
};

export const SUPPORTED_COUNTRIES = [
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Vietnam', value: 'Vietnam' },
  { label: 'Test', value: 'Test' },
];

export const FARMER_STATUS = [
  { label: 'All', value: null },
  { label: 'Active ', value: 'Active' },
  { label: 'Inactive', value: 'INACTIVE' },
];

export const AGRONOMISTS = [
  { value: 'Irfan', key: 'Irfan' },
  { value: 'Rianto', key: 'Rianto' },
];

export const SEASONS = [{ key: 'PS1-2022', value: '4' }];

export const SEASONS_STATUS = [
  { label: 'Active ', value: 'Active' },
  // { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Harvested ', value: 'HARVESTED' },
];

export const ROLES = [
  { label: 'Product Manager', value: 'PM' },
  { label: 'General Manager', value: 'GM' },
  { label: 'Area Manager', value: 'Area Manager' },
  { label: 'Territory Manager', value: 'TM' },
  { label: 'AWD Manager', value: 'AWD Manager' },
  { label: 'Agronomist - Sales', value: 'Agronomist - Sales' },
  { label: 'Agronomist - AWD', value: 'Agronomist - AWD' },
  { label: 'Jr Agronomist', value: 'Jr Agronomist' },
  { label: 'Sr Agronomist', value: 'Sr Agronomist' },
  { label: 'AWD - Worker', value: 'AWD - Worker' },
];

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
  UPCOMING: 'UPCOMING',
  COMPLETED: 'COMPLETED',
  HARVESTED: 'HARVESTED',
  OVERDUE: 'OVERDUE',
  COMPLETED_WITH_DELAY: 'COMPLETED_WITH_DELAY',
  LATE: 'LATE',
  INCOMPLETE: 'INCOMPLETE',
  COMPLETED_PARTIALLY: 'COMPLETED_PARTIALLY',
};

export type StatusMapValue = (typeof STATUS_MAP)[keyof typeof STATUS_MAP];

type StatusConfig = {
  text: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  color: string;
  toolTipIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  textColor?: string;
  iconColor?: string;
};

export const STATUS_MAP: Record<string, StatusConfig> = {
  UPCOMING: {
    text: t('status.Upcoming'),
    icon: IconUpcomming,
    color: colors.tag_blue,
    toolTipIcon: TTIconUpcomming,
  },
  PENDING: {
    text: t('status.PENDING'),
    icon: IconPending,
    color: colors.tag_orange,
    toolTipIcon: TTIconPending,
  },
  OVERDUE: {
    text: t('status.Overdue'),
    icon: IconOverdue,
    color: colors.tag_orange,
    toolTipIcon: TTIconOverdue,
  },
  COMPLETED: {
    text: t('status.Completed'),
    icon: IconCompleted,
    color: colors.tag_color_harvested,
    toolTipIcon: TTIconCompleted,
  },
  COMPLETED_WITH_DELAY: {
    text: t('status.completedWithDelay'),
    icon: IconCompletedWithDelay,
    color: colors.tag_yellow,
    toolTipIcon: TTIconCompletedWithDelay,
  },
  COMPLETED_PARTIALLY: {
    text: t('status.Filled'),
    icon: IconFilled,
    color: colors.tag_green,
    toolTipIcon: TTIconFilled,
  },
  LATE: {
    text: t('status.Late'),
    icon: IconLate,
    color: colors.tag_orange,
    toolTipIcon: TTIconLate,
  },
  INCOMPLETE: {
    text: t('status.Incomplete'),
    icon: IconIncomplete,
    color: colors.tag_orange,
    toolTipIcon: TTIconIncomplete,
  },
  ACTIVE: {
    text: t('status.Active'),
    icon: IconActiveNow,
    color: colors.tag_green,
    toolTipIcon: TTIconActiveNow,
  },
  INACTIVE: {
    text: t('status.Inactive'),
    icon: IconInactive,
    color: colors.tag_gray,
    toolTipIcon: TTIconInactive,
  },
  BLOCKED: {
    text: 'Blocked',
    icon: IconBlocked,
    color: '#D6D6D6',
    toolTipIcon: IconBlocked,
    textColor: '#545454',
    iconColor: '#A3A3A3',
  },
};

export const USERS_ROLE = [
  { label: 'PM', value: 'PM' },
  { label: 'GM', value: 'GM' },
  { label: 'Sales Agronomist', value: 'Agronomist - Sales' },
  { label: 'AWD Agronomist', value: 'Agronomist - AWD' },
  { label: 'Territory Manager', value: 'TM' },
  { label: 'Area Manager', value: 'Area Manager' },
  { label: 'Farmer Group Leader', value: 'CUBELEADER' },
];

export const ALLOWED_USER_ROLE = [
  'Admin',
  'Sr Agronomist',
  'Jr Agronomist',
  'Jr Agronomist (External)',
  'OM',
  'GM',
  'PM',
  'Area Manager',
] as const;

export enum Roles {
  Admin = 'Admin',
  TerritoryManager = 'TM',
  AwdManager = 'AWD Manager',
  SalesAgronomist = 'Agronomist - Sales',
  AwdAgronomist = 'Agronomist - AWD',
  OM = 'OM',
  GM = 'GM',
  PM = 'PM',
  AreaManager = 'Area Manager',
  JrAgronomist = 'Jr Agronomist',
  SrAgronomist = 'Sr Agronomist',
}

export const ROLE_GROUPS = {
  ALL: ALLOWED_USER_ROLE as unknown as Roles[],
  ALL_EXCEPT_JR_AG: [
    Roles.Admin,
    Roles.PM,
    Roles.AreaManager,
    Roles.GM,
    Roles.OM,
    Roles.TerritoryManager,
    Roles.AwdManager,
  ],
  MANAGERS: [Roles.Admin, Roles.PM, Roles.AreaManager, Roles.GM, Roles.OM],
  ADMIN_AND_PM: [Roles.Admin, Roles.PM],
  JR_AGS: [Roles.SalesAgronomist, Roles.AwdAgronomist, Roles.JrAgronomist],
  AGS_PM_AND_ADMIN: [
    Roles.SalesAgronomist,
    Roles.AwdAgronomist,
    Roles.TerritoryManager,
    Roles.JrAgronomist,
    Roles.AwdManager,
    Roles.SrAgronomist,
    Roles.PM,
    Roles.Admin,
  ],
  PM_ADMIN_AND_JR_AGS: [
    Roles.SalesAgronomist,
    Roles.AwdAgronomist,
    Roles.JrAgronomist,
    Roles.PM,
    Roles.Admin,
  ],
  AGS: [
    Roles.SalesAgronomist,
    Roles.AwdAgronomist,
    Roles.TerritoryManager,
    Roles.JrAgronomist,
    Roles.AwdManager,
    Roles.SrAgronomist,
  ],
  SR_AGS: [Roles.TerritoryManager],
};

export const PIPE_STATUS = [
  {
    type: 'status',
    label: 'Manually rejected',
    value: 'MANUALLY_REJECTED',
  },
  {
    type: 'status',
    label: 'Unserviced',
    value: 'UNSERVICED',
  },
  {
    type: 'status',
    label: 'Drying event: Rejected',
    value: 'DRYING_EVENT_REJECTED',
  },
  {
    type: 'status',
    label: 'Serviced',
    value: 'SERVICED',
  },
];

export const PICTURE_STATUS = [
  {
    label: 'Approved',
    value: 'APPROVED',
  },
  {
    label: 'Rejected',
    value: 'REJECTED',
  },
  {
    label: 'In Review',
    value: 'IN_REVIEW',
  },
];

export const PIPE_RELATED_TASK_TYPES = [
  {
    label: 'Pipe Installation',
    value: 'Pipe Installation',
  },
  {
    label: 'Drying Event',
    value: 'Drying Event',
  },
  {
    label: 'Second Drying Event',
    value: 'Drying Event 2',
  },
  {
    label: 'Third Drying Event',
    value: 'Drying Event 3',
  },
];

export const CONTRACT_STATUS = [
  {
    label: 'Contract Needed',
    value: 'NONE',
  },
  {
    label: 'Has Contract',
    value: 'VERIFIED',
  },
];

export const PIPE_REVIEW_STATUS = {
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  AUTO_APPROVED: 'AUTO_APPROVED',
  AUTO_REJECTED: 'AUTO_REJECTED',
  FAILED: 'FAILED',
  UPLOADED: 'UPLOADED',
  OVERDUE: 'OVERDUE',
};

export const PIPE_CHANGE_LOG_TO_STATUS_MAP = {
  UPLOAD: PIPE_REVIEW_STATUS.UPLOADED,
  REVIEW_APPROVED: PIPE_REVIEW_STATUS.APPROVED,
  REVIEW_REJECTED: PIPE_REVIEW_STATUS.REJECTED,
  AUTO_REVIEW_APPROVED: PIPE_REVIEW_STATUS.AUTO_APPROVED,
  AUTO_REVIEW_REJECTED: PIPE_REVIEW_STATUS.AUTO_REJECTED,
  AUTO_REVIEW_FAILED: PIPE_REVIEW_STATUS.FAILED,
};

export const PICTURE_REJECTION_REASONS = [
  'Pipe is not found',
  'Pipe is hidden by vegetation',
  'Picture is too zoomed in',
  'Picture is too zoomed out',
  'Picture is not taken at the right angle',
];

export const PICTURE_APPROVAL_REASONS = [
  'The picture is clear enough',
  'Picture is taken at the right angle',
];

export const ERRORS = {
  EMPTY_DATA: 'No data available',
};

export const formProps = {
  labelCol: { lg: { span: 5 } },
  wrapperCol: { lg: { span: 12 } },
  labelAlign: 'left' as const,
};

export const groupTypeOptions = [
  // { label: 'Sales Only', value: 'SALES_GROUP' },
  { label: 'Planting Group', value: 'PLANTING_GROUP' },
  { label: 'Full Stack Group', value: 'FULL_STACK_GROUP' },
];

export const STAKEHOLDER_TYPES = {
  Vietnam: {
    PB: t('common.coop'),
  },
  Indonesia: {
    PB: t('common.paddyBuyer'),
  },
};

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 1;